import { _x } from '@wordpress/i18n'
import { t } from '../../../../assets/utils/algolia/algoliaLocalization'
import { TranslatedHighlight } from '../../../../assets/utils/algolia/algoliaTranslation'
import type { HitComponentTemplateProps } from './HitComponent'

export default function ListHitComponent({
  hit,
  isNew,
  speakers,
  detailUrl,
  teaser
}: HitComponentTemplateProps) {
  return (
    <article
      data-bs-theme="dark"
      className="card"
      style={{
        viewTransitionName: `card-${hit.objectID}`
      }}
    >
      <div className="card-body p-3 p-md-5">
        {(isNew || !!location) && (
          <div className="d-flex justify-content-between justify-content-md-start align-items-center mb-2 mb-md-4 gap-2 flex-wrap">
            {isNew && (
              <div className="badge text-bg-primary order-2 order-md-1">
                {_x('NEW', 'New Tag', 'icf')}
              </div>
            )}
            <div className="d-flex flex-wrap gap-1">
              {speakers.map((s) => (
                <div key={s} className="card-meta-tag">
                  {s}
                </div>
              ))}
            </div>
          </div>
        )}
        <div className="row">
          <div className={teaser ? 'col-12 col-lg-4' : 'col-12 col-md-6'}>
            <div className="d-flex flex-column h-100">
              <h3 className="mb-4 mb-lg-3">
                <TranslatedHighlight hit={hit} attribute="topic" />
              </h3>
            </div>
          </div>
          {!!teaser && (
            <div className="col-5 d-none d-lg-block">
              <p className="fs-sm">
                {teaser}
              </p>
            </div>
          )}
          <div className={teaser ? 'col-12 col-lg-3' : 'col-12 col-md-6'}>
            <div className="d-flex justify-content-md-end gap-1">
              {!!detailUrl && (
                <a
                  href={detailUrl}
                  className="btn btn-sm btn-dark-1 card-stretched-link"
                  aria-label={`${_x('Watch sermon', 'Sermons List Card Detail Link Screenreader Text', 'icf')} ${t(hit.topic, { fallback: 'none' })}`}
                >
                  <span>
                    {_x(
                      'Watch now',
                      'Sermons List Card Detail Link Button',
                      'icf'
                    )}
                  </span>
                  <i className="icon fa-arrow-right" />
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </article>
  )
}
